module.exports = __webpack_public_path__ + "img/user-10.e80af558.svg";